import { authHeader, ApiConfigs } from "../_helpers";

export const investigationsService = {
  getAll,
  submitInvestigation,
};

function getAll(id) {
  const requestOptions = {
    method: "GET",
    credentials : 'include',
    headers: { ...authHeader() },
  };
  return fetch(
    `${ApiConfigs.base_user_url +
      ApiConfigs.investigations.getAll.replace(":id", id)}`,
    requestOptions
  ).then(handleResponse);
}

function submitInvestigation(payload) {
  const requestOptions = {
    method: "POST",
    credentials : 'include',
    headers: { ...authHeader() },
    body: payload,
  };

  return fetch(
    `${ApiConfigs.base_user_url + ApiConfigs.investigations.submitInvestigation}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        //logout();
        //location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
